// extracted by mini-css-extract-plugin
module.exports = {"grid":"OnlineServicesSection_grid__x2UaG"};